import React, { FC } from "react";
import { useParams } from "react-router-dom";
import { OrderTrackingLayout } from "@/pages/OrderTracking/components/OrderTrackingLayout/order-tracking-layout";
import { toLcrTrackingView } from "@/pages/OrderTracking/Lcr/lcr-tracking-view.mapper";
import { useLcrOrder } from "@/pages/OrderTracking/Lcr/hooks/use-lcr-order.hook";

const LcrOrderTrackingPage: FC = () => {
  const { serialNumber } = useParams<{ serialNumber?: string }>();
  const { data: order } = useLcrOrder(serialNumber);

  return order ? <OrderTrackingLayout view={toLcrTrackingView(order)} /> : null;
};

export default LcrOrderTrackingPage;
